"use client";
import * as React from "react";
const SvgBackspaceRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14.655 0H4.57c-.464 0-.827.233-1.07.587L.112 5.633a.672.672 0 0 0 0 .74l3.389 5.04c.242.347.605.587 1.069.587h10.086c.74 0 1.345-.6 1.345-1.333V1.333A1.344 1.344 0 0 0 14.655 0Zm-2.488 8.867a.674.674 0 0 1-.948 0L9.276 6.94 7.333 8.867a.674.674 0 0 1-.948 0 .66.66 0 0 1 0-.94L8.328 6 6.385 4.073a.66.66 0 0 1 0-.94.674.674 0 0 1 .948 0L9.276 5.06l1.943-1.927a.674.674 0 0 1 .948 0 .66.66 0 0 1 0 .94L10.224 6l1.943 1.927a.672.672 0 0 1 0 .94Z" }));
export {
  SvgBackspaceRound as default
};
